import {Component, Inject} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {MatButton} from "@angular/material/button";
import {TranslatePipe} from "@ngx-translate/core";
import {MsalService} from "@azure/msal-angular";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-logout-dialog',
  imports: [
    MatDialogActions,
    MatDialogContent,
    MatButton,
    TranslatePipe
  ],
  templateUrl: './logout-dialog.component.html',
  styleUrl: './logout-dialog.component.css'
})
export class LogoutDialogComponent {
  constructor(
      public readonly dialogRef: MatDialogRef<LogoutDialogComponent>,
      private readonly router: Router,
      private readonly authService: MsalService,
      @Inject(DOCUMENT) private readonly document: Document,
  ) {
  }

  onLogin(): void {
    this.authService.loginPopup({
      scopes: environment.msalConfig.api.resourceScopes,
    }).subscribe({
      next: (response) => {
        this.authService.instance.setActiveAccount(response.account);
        this.dialogRef.close();
        this.document.location.href = '/ui/home';
      },
      error: (error) => {
        console.error('Login failed:', error);
      }
    });
  }
}
